import styled from "styled-components";
import { FontFamily, GlobalColors } from "../../../global-files/variables";

export const Container = styled.div`

  &.invisible {
    display: none !important;
  }

  .title-container {
    position: relative;

    display: flex;
    align-items: center;
    gap: .5rem;

    .icon_information{
      width: 1.35rem;
      height: 1.35rem;
      filter: brightness(.35);
    }

    .tooltip {
      display: none;
      position: absolute;
      background-color: ${GlobalColors.white};
      color: ${({ color }) => (color ? color : GlobalColors.s5)};
      font-family: ${FontFamily.Raleway};
      font-size: 14px;
      line-height: 19px;
      left: 0;
      top: 0;
      height: fit-content;
      transition: display 2s;
    }

    &:hover {
      .tooltip {
        display: block;
      }
    }
  }

  & > :first-child {
    & + * {
      margin-top: ${({ inputType }) => (inputType !== "textarea" ? 4 : 15)}px;
    }
  }
  & + * {
    margin-top: ${({ inputType }) => (inputType !== "textarea" ? 0 : 10)}px;
  }
`;
